"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _searchWebHost = 'http://www.local.aperza.com:8080';

var AperzaLinkUtil = /*#__PURE__*/function () {
  function AperzaLinkUtil() {
    _classCallCheck(this, AperzaLinkUtil);
  }

  _createClass(AperzaLinkUtil, null, [{
    key: "createCompanyPageUrl",
    value: function createCompanyPageUrl(_ref) {
      var companyContractDisplayId = _ref.companyContractDisplayId;
      return "".concat(_searchWebHost, "/co/").concat(companyContractDisplayId);
    }
  }, {
    key: "createCatalogPageUrl",
    value: function createCatalogPageUrl(_ref2) {
      var companyContractDisplayId = _ref2.companyContractDisplayId,
          catalogId = _ref2.catalogId,
          _ref2$lang = _ref2.lang,
          lang = _ref2$lang === void 0 ? 'ja' : _ref2$lang;
      return "".concat(_searchWebHost, "/").concat(lang, "/co/").concat(companyContractDisplayId, "/catalog/").concat(catalogId);
    }
  }, {
    key: "searchWebHost",
    set: function set(value) {
      _searchWebHost = value;
    }
  }]);

  return AperzaLinkUtil;
}();

exports.default = AperzaLinkUtil;